import React from 'react';
import '../../components/css/popupstyle.css';
import changePasswordIcon from '../.././components/css/dark/img/theme-images/change-password.svg';
import deleteIcon from '../.././components/css/dark/img/theme-images/delete.svg';
import $ from 'jquery';
import Pagination from "react-js-pagination";
import { userService } from '../../_services';
import { debuglog } from 'util';
import * as signalR from '@aspnet/signalr';

class ManageEmail extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loader: true,
            userdata: JSON.parse(localStorage.getItem('user')),
            activePage: 1,
            UserList: [],
            UserList_Temp: [],
            createNewUser: false,
            userNameError: '',
            userEmailError: '',
            mainAPIresult: [],
            error: '',
            Data_Not_Found: '',
        }
    }
    componentDidMount() {
        this.fetchDataLocally(this.state.userdata.paramsname, this.state.userdata.userrole, this.props.dataId);
        setTimeout(() => {
            $('.popup').addClass('mfp-ready');
            $('.popup').addClass('mfp-bg');
            $('.popup').addClass('mfp-with-anim');
        }, 5);
    }
    fetchDataLocally(roleName, roleType, id) {
        try {
            userService.GetDashboardList(roleName, roleType, id).then(
                apidata => {
                    try {
                        if (apidata.length <= 12) {
                            $('.manage-email').addClass('less-than');
                            this.setState({ UserList: apidata, mainAPIresult: apidata, UserList_Temp: apidata, loader: false });
                        }
                        else {
                            $('.manage-email').removeClass('less-than');
                            let userlistobj = JSON.parse(JSON.stringify(apidata));
                            let usertemplistobj = userlistobj.length > 12 ? userlistobj.splice(0, 12) : userlistobj;
                            this.setState({ UserList: apidata, mainAPIresult: apidata, UserList_Temp: usertemplistobj, loader: false });
                        }
                    }
                    catch (error) {
                    }
                });
        }
        catch (error) {
        }
    }
    handleResponse(response) {
        return response.text().then(text => {
            try {
                const data = text && JSON.parse(text);
                return data;
            }
            catch (error) {
                const data = [];
                return data;
            }
        });
    }
    handlePageChange = (pageNumber) => {
        let userlistobj = JSON.parse(JSON.stringify(this.state.UserList));
        let usertemplistobj = userlistobj.length > 12 ? userlistobj.splice((pageNumber - 1) * 12, 12) : userlistobj;
        this.setState({ activePage: pageNumber, UserList_Temp: usertemplistobj, loader: false });
    }
    changePassword = (e) => {
        let wholesalerName = this.props.wholesalerName;
        let userName = $(e.target).attr('datausername');
        let userEmail = $(e.target).attr('dataemail');
        this.props.closeResetPasswordPopup(wholesalerName, userName, userEmail);
        this.props.closePopup(this.props.dataId, this.props.wholesalerId, this.props.wholesalerName, this.props.activePagin);
    }
    deleteUser = (e) => {
        let userName = $(e.target).attr('datausername');
        let userEmail = $(e.target).attr('dataemail');
        this.props.closeDeleteUserPopup(userName, userEmail);
        this.props.closePopup(this.props.dataId, this.props.wholesalerId, this.props.wholesalerName, this.props.activePagin);
    }
    addUser = (e) => {
        $(e.target).attr("disabled", true);
        $('.not-available').text("");
        this.setState({ createNewUser: true, error: '' });
    }
    saveData = (e) => {
        $(e.target).attr("disabled", true);
        this.setState({ loader: true });

        // get input field values
        let htmlprefix = $(e.target).parents('.userDashData');
        let userName = htmlprefix.find('input[name = "userName"]').val();
        let email = htmlprefix.find('input[name = "email"]').val();
        let whName = this.props.wholesalerName;
        let whId = this.props.wholesalerId;
        let userValidated = false;
        let emailValidated = false;

        if (!userService.Check_Null_Empty(userName)) {
            if (userName == "User Name") {
                this.setState({ userNameError: 'User Name cannot be blank', loader: false });
                $(e.target).attr("disabled", false);
                userValidated = false;
            } else if (userService.ValidateSpace(userName)) {
                this.setState({ userNameError: 'Space not acceptable', loader: false });
                $(e.target).attr("disabled", false);
                userValidated = false;
            } else {
                userValidated = true;
            }

        } else {
            this.setState({ userNameError: 'User Name cannot be blank', loader: false });
            $(e.target).attr("disabled", false);
            userValidated = false;
        }
        if (!userService.Check_Null_Empty(email)) {
            if (email == "Email") {
                this.setState({ userEmailError: 'Email ID cannot be blank', loader: false });
                $(e.target).attr("disabled", false);
                emailValidated = false;
            } else {
                if (userService.ValidateEmail(email)) {
                    emailValidated = true;
                }
                else {
                    this.setState({ userEmailError: 'Enter a valid email ID', loader: false });
                    $(e.target).attr("disabled", false);
                    emailValidated = false;
                }
            }
        }
        else {
            this.setState({ userEmailError: 'Email ID cannot be blank', loader: false });
            $(e.target).attr("disabled", false);
            emailValidated = false;
        }

        if (userValidated == true && emailValidated == true) {
            this.createUser(this.state.userdata.paramsname, this.state.userdata.userrole, whName, whId, userName, email);
        }

    }
    createUser(roleName, roleType, whName, whId, userName, userEmail) {
        try {
            userService.AddWhDashUser(roleName, roleType, whName, whId, userName, userEmail).then(
                apidata => {
                    try {
                        if (apidata[0].status_code == "1") {
                            let userList = this.state.UserList;
                            let newList = {
                                userName: userName,
                                email: userEmail
                            }
                            userList.push(newList)
                            this.setState({ UserList: userList, mainAPIresult: userList, UserList_Temp: userList, loader: false, createNewUser: false, error: apidata[0].status_message, userEmailError: '', userNameError: '' });
                            $('.add-wholesaler').attr("disabled", false);
                        } else {
                            this.setState({ error: apidata[0].status_message, loader: false });
                            $('.save').attr("disabled", false);
                        }
                    }
                    catch (error) {
                        this.setState({ error: 'Error', loader: false });
                        $('.save').attr("disabled", false);
                    }
                });
        }
        catch (error) {
        }
    }
    cancelData = () => {
        this.setState({ createNewUser: false, userNameError: '', userEmailError: '', loader: false, error: '' });
        $('.add-wholesaler').attr("disabled", false);
    }
    handleBack = () => {
        this.props.closePopup();
        this.props.openWholesalerPopup(this.props.activePagin, this.props.whSearch);
    }
    removeDefault = (e) => {
        if ($(e.target).val() == 'User Name' || $(e.target).val() == 'Email') {
            $(e.target).val("");
            this.setState({ userEmailError: '', userNameError: '', error: '' });
        } else {
            this.setState({ userEmailError: '', userNameError: '', error: '' });
        }
    }
    SearchOnKeyUp = e => {
        let serachText = e.target.value;
        let userlistobj = JSON.parse(JSON.stringify(this.state.mainAPIresult)).filter(function (e1) {
            return (e1.userName.toLowerCase().indexOf(serachText.toLowerCase()) !== -1 || e1.email.toLowerCase().indexOf(serachText.toLowerCase()) !== -1)
        });
        let copyuserlistobj = JSON.parse(JSON.stringify(this.state.mainAPIresult)).filter(function (e1) {
            return (e1.userName.toLowerCase().indexOf(serachText.toLowerCase()) !== -1 || e1.email.toLowerCase().indexOf(serachText.toLowerCase()) !== -1)
        });

        if (userlistobj.length == 0 || copyuserlistobj.length == 0) this.setState({ Data_Not_Found: 'No records found' });

        let usertemplistobj = userlistobj.length > 12 ? userlistobj.splice(0, 12) : userlistobj;
        this.setState({ activePage: 0, UserList: copyuserlistobj, UserList_Temp: usertemplistobj, loader: false });
    }
    financeUser = (e) => {
        $(e.target).siblings('.hide-loader').css("display", "block");
        $(e.target).siblings('.finance-message').css("display", "block");
        let htmlprefix = $(e.target).parents('.userDashData');
        let isfu = htmlprefix.find('#Fuser').is(':checked');
        let issupport = htmlprefix.find('#Suser').is(':checked');
        let istechnical = htmlprefix.find('#Tuser').is(':checked');
        this.Set_Update_FinanceUser(e.target.getAttribute('dataName'), e.target.getAttribute('dataEmail'), this.props.wholesalerId.toString(),isfu,issupport,istechnical);
    }
    Set_Update_FinanceUser(fusername, fuseremail, whid, isfu, issupport, istechnical) {
        try {
            userService.UpdateFinanceUser(fusername, fuseremail, whid, isfu, issupport, istechnical).then(
                apidata => {
                    try {
                        if (apidata.length > 0) {
                            if (apidata[0].status_code == "1") {
                                this.setState({ error: apidata[0].status_message, loader: false });
                                $('.hide-loader').css("display", "none");
                                setTimeout(() => {
                                    this.setState({ error: '' });
                                }, 2000);
                                this.fetchDataLocally(this.state.userdata.paramsname, this.state.userdata.userrole, this.props.dataId);
                                try {
                                    var connection = new signalR.HubConnectionBuilder().withUrl("/fuser").build();
                                    connection.start().then(() => {
                                        connection.invoke("UpdateFinanceUser", whid, fuseremail).catch(err => console.error(err.toString()));
                                    });
                                } catch (err) {
                                }

                            } else {
                                this.setState({ error: apidata[0].status_message, loader: false });
                                $('.hide-loader').css("display", "none");
                                setTimeout(() => {
                                    this.setState({ error: '' });
                                }, 2000);
                            }
                        } else {
                            this.setState({ error: 'Error! Please try again.', loader: false });
                            $('.hide-loader').css("display", "none");
                            setTimeout(() => {
                                this.setState({ error: '' });
                            }, 2000);
                        }
                    }
                    catch (error) {
                        this.setState({ error: 'Error! Please try again.', loader: false });
                    }
                }
            );
        }
        catch (error) {
            this.setState({ error: 'Opps!, Something went wrong. Try Again.' });
        }
    }
    render() {
        const { userNameError, userEmailError, error } = this.state
        let disabled = false;
        disabled = this.state.loader ? true : false;

        return (
            <div className="manage-scroll manage-distributor-design">
                <div className='popup mfp-zoom-in manage-email tooltip-mail-section'>
                    <div className='popup_inner'>
                        <h1>{this.props.titleText}<button onClick={this.handleBack}>X</button></h1>
                        {
                            this.state.loader ? (<div className="theme-loader"></div>) : null
                        }
                        <button className="btn add-wholesaler back email-btn" onClick={disabled ? null : this.handleBack}>Back</button>
                        <button className="btn add-wholesaler" onClick={disabled ? null : this.addUser}>Add User</button>
                        <div className="searchSection populate">
                            <form autoComplete="off" onSubmit={e => { e.preventDefault() }}>
                                <div className="autocomplete">
                                    <input id="SearcInput" type="text" name="PhCityInput" scroll-id="CITY" data-id="dynamic" placeholder="Search" onKeyUp={this.SearchOnKeyUp} className="form-control searchTable searchtextarea" />
                                </div>
                            </form>
                        </div>
                        <div className="welcome">
                            {
                                this.state.createNewUser ?
                                    <table className="add-new-user new">
                                        <tbody>
                                            <tr className="userDashData">
                                                <td className="first-one">
                                                    <input type="text" defaultValue="User Name" onFocus={this.removeDefault} className="form-control" name="userName" />
                                                    {userNameError &&
                                                        <div className={'alert alert-danger'}>{userNameError}</div>
                                                    }
                                                </td>
                                                <td className="second-one">
                                                    <input type="email" defaultValue="Email" onFocus={this.removeDefault} className="form-control" name="email" />
                                                    {userEmailError &&
                                                        <div className={'alert alert-danger'}>{userEmailError}</div>
                                                    }
                                                </td>
                                                <td className="third-one">
                                                    <input type="button" className="btn save" onClick={this.saveData} value="Save" />
                                                    <input type="button" className="btn cancel" onClick={this.cancelData} value="Cancel" />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table> : null
                            }

                            <div>
                                {
                                    this.state.loader ? <div className="please-wait"><h3>Please wait...</h3></div> :
                                        <div>
                                            {
                                                this.state.UserList != null && this.state.UserList.length > 0 ?
                                                    <table>
                                                        <thead>
                                                            <tr className="header">
                                                                <th className="first-one">User Name</th>
                                                                <th className="second-one">Email</th>
                                                                <th className="fourth-one">Finance</th>
                                                                <th className="fifth">Technical</th>
                                                                <th className="sixth">Support</th>
                                                                <th className="third-one">Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody id="inactive_reps">
                                                            {

                                                                this.state.UserList_Temp.map((e1, i1) => {
                                                                    return (
                                                                        <tr className="userDashData" key={i1}>
                                                                            <td className="first-one">
                                                                                {e1.userName}
                                                                            </td>
                                                                            <td className="second-one">
                                                                                {e1.email}
                                                                            </td>
                                                                            <td className="fourth-one">
                                                                                <input id="Fuser" dataEmail={e1.email} dataName={e1.userName} checked={e1.isfu == true ? true : false} type="radio" name={this.props.wholesalerName} value={this.props.wholesalerName} onClick={this.financeUser} className="form-control" />
                                                                                <span>&nbsp;</span>
                                                                                <div className="hide-loader"><div className="theme-loader resetLoader"></div></div>
                                                                            </td>
                                                                            <td className="fifth">
                                                                                <input id="Tuser" dataEmail={e1.email} dataName={e1.userName} checked={e1.istechnical == true ? true : false} type="radio" name='tech' value={this.props.wholesalerName} onClick={this.financeUser} className="form-control" />
                                                                                <span>&nbsp;</span>
                                                                                <div className="hide-loader"><div className="theme-loader resetLoader"></div></div>
                                                                            </td>
                                                                            <td className="sixth">
                                                                                <input id="Suser" dataEmail={e1.email} dataName={e1.userName} checked={e1.issupport == true ? true : false} type="radio" name='support' value={this.props.wholesalerName} onClick={this.financeUser} className="form-control" />
                                                                                <span>&nbsp;</span>
                                                                                <div className="hide-loader"><div className="theme-loader resetLoader"></div></div>
                                                                            </td>
                                                                            <td className="third-one">
                                                                                <a href="javascript:void('0')" className="custom-tooltip"><img onClick={this.changePassword} datausername={e1.userName} dataemail={e1.email} src={changePasswordIcon} className="change-password" alt="change Password" /><span className="hover-tooltip change-Password">Change Password</span></a>
                                                                                {
                                                                                    e1.userName == this.props.wholesalerName ? null :
                                                                                        <div>
                                                                                            {e1.isfu == true || e1.issupport == true || e1.istechnical == true ? null : <a href="javascript:void('0')" className="custom-tooltip"><img onClick={this.deleteUser} datausername={e1.userName} dataemail={e1.email} src={deleteIcon} className="delete-icon" alt="delete User" /><span className="hover-tooltip delete-icon">Delete User</span></a>}
                                                                                        
                                                                                </div>
                                                                                            }
                                                                            </td>
                                                                        </tr>
                                                                    )
                                                                })
                                                            }
                                                        </tbody></table> :
                                                    <div>
                                                        {
                                                            this.state.loader ? null :
                                                                <div className="not-available please-wait color-red"><h3>{this.state.Data_Not_Found}</h3></div>
                                                        }
                                                    </div>
                                            }
                                        </div>
                                }
                            </div>

                            {
                                this.state.UserList.length > 12 ?
                                    <Pagination
                                        activePage={this.state.activePage}
                                        itemsCountPerPage={12}
                                        totalItemsCount={this.state.UserList.length}
                                        pageRangeDisplayed={5}
                                        onChange={this.handlePageChange.bind(this)}
                                    /> : null
                            }
                        </div>
                        {error &&
                            <div className={'alert alert-danger email'}>{error}</div>
                        }

                    </div>
                </div>
            </div>
        )
    }
}

export default ManageEmail;